import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Topbar } from './layout/topbar/topbar';
import { Sidebar } from './layout/sidebar/sidebar';
import { ProjectIdInterceptor } from './core/interceptors/project-id.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { RequestIdInterceptor } from './core/interceptors/request-id.interceptor';
import { SharedModule } from './shared/shared-module';

@NgModule({
  declarations: [
    App,
    Topbar,
    Sidebar
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ProjectIdInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestIdInterceptor, multi: true },
  ],
  bootstrap: [App]
})
export class AppModule { }
